<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ $t("inventory_transfer") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>

        <div class="col-lg-6 col-5 text-right">
          <base-button size="md" type="neutral" @click="handleInventory()">{{
            $t("back")
          }}</base-button>
          <base-button size="md" type="primary" :loading="isLoading" @click="handlInventoryTransfer()">{{
            $t("save")
          }}</base-button>
        </div>
      </div>
    </base-header>

    <div class="row">
      <div class="container-fluid mt--6 col-lg-6">
        <div>
          <card
            class="no-border-card"
            body-classes="px-0 pb-1"
            footer-classes="pb-2"
          >
            <template slot="header">
              <h3 class="mb-0">{{ $t("wms.inventory_dst") }}</h3>

              <base-input>
                    <el-select
                      v-model="StorageID"
                      :placeholder="$t('wms.storage')"
                    >
                      <el-option
                        v-for="option in StorageDst"
                        :key="option.ID"
                        :label="option.Name"
                        :value="option.ID"
                      >
                      </el-option>
                    </el-select>
                  </base-input>


            </template>

             <div class="form-group row">
              <label class="col-md-3 pl-6 col-form-label form-control-label">
                {{ $t("wms.bill_number") }}
              </label>
              <div class="col-md-8">
                <base-input v-model="inOut.BillCode"></base-input>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-md-3 pl-6 col-form-label form-control-label">
                {{ $t("wms.bill_image") }}
              </label>
              <div class="col-md-8">
                <form>
                  <file-input @change="filesChange"></file-input>
                </form>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-md-3 pl-6 col-form-label form-control-label">
                {{ $t("wms.note") }}
              </label>
              <div class="col-md-8">
                <base-input v-model="inOut.Note"></base-input>
              </div>
            </div>

            <div
              class="form-group row"
              v-for="(item,index) in ProductSelect"
              :key="item.ID"
            >
              <label class="col-md-6 pl-6 col-form-label form-control-label">
                {{ item.Name }}
              </label>
              <div class="col-md-3">
                <base-input v-model="item.Quantity"></base-input>
              </div>
              <div class="col-md-3">
                <base-button
                  @click.native="handleDelete(index, item)"
                  class="remove btn-link"
                  type="danger"
                  size="md"
                  icon
                >
                  <i class="text-dtac-bt fa fa-trash text-white"></i>
                </base-button>
              </div>
            </div>
          </card>
        </div>
      </div>

      <div class="container-fluid mt--6 col-lg-6">
        <div>
          <card
            class="no-border-card"
            body-classes="px-0 pb-1"
            footer-classes="pb-2"
          >
            <template slot="header">
              <div class="row">
                <label class="col-md-6 col-form-label form-control-label">
                  <h3 class="mb-0">{{ $t("wms.inventory_main") }}</h3>
                </label>
                <div class="col-md-6">
                  <base-input
                    v-model="SearchKeyword"
                    prepend-icon="fas fa-search"
                    :placeholder="$t('search')"
                  >
                  </base-input>
                </div>
              </div>
            </template>
            <div>
          
              <el-table
                :data="queriedData"
                row-key="id"
                header-row-class-name="thead-light"
                @sort-change="sortChange"
                @selection-change="selectionChange"
              >
                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  v-bind="column"
                >
                </el-table-column>

                <el-table-column
                  min-width="200px"
                  align="right"
                  :label="$t('actions')"
                >
                  <div slot-scope="{ $index, row }" class="d-flex">
                    <base-button
                      @click.native="handleOut($index, row)"
                      class="edit"
                      type="warning"
                      size="sm"
                      icon
                    >
                      <i class="text-dtac-bt fa fa-edit"></i>
                      {{ $t("wms.inventory_out") }}
                    </base-button>
                  </div>
                </el-table-column>
              </el-table>
            </div>
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
			  v-if="tableData.length != 0"
            >
              <div class="">
                <p class="card-category">
                  {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
                  {{ $t("of") }}
                  {{ total }}
                  <span v-if="selectedRows.length">
                    - &nbsp; &nbsp; {{ selectedRows.length }}
                    {{ $t("row_select") }}
                  </span>
                </p>
              </div>
              <base-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
              >
              </base-pagination>
            </div>
          </card>
        </div>
      </div>
    </div>









<!--  Modal -->
    <modal :show.sync="showInOutModal" modal-classes="modal-secondary">
      <form class="new-event--form" @submit.prevent="saveEvent">
        <base-input v-model="inOut.ProductName" :label="$t('wms.product')">
        </base-input>

        <base-input
          v-model="inOut.Quantity"
          :label="$t('wms.amount')"
          input-classes="form-control-alternative new-event--title"
        >
        </base-input>

        <input type="hidden" class="new-event--start" />
        <input type="hidden" class="new-event--end" />
      </form>

      <template slot="footer">
        <button
          type="submit"
          class="btn btn-md btn-primary"
          @click="handleUpdateSelect()"
        >
          {{ $t("save") }}
        </button>
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showInOutModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import error from "./error";
import { mapGetters, mapActions } from "vuex";
import FileInput from '@/components/Inputs/FileInput'

export default {
  mixins: [clientPaginationMixin],
  components: {
      FileInput,
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {
    ...mapGetters({
      tableDataOrg: "WmsInventory/getData",
      Product: "WmsProduct/getData",
      Storage: "WmsStorage/getData",
    }),
    tableData: function () {
      if (this.SearchKeyword != "") {
        return this.tableDataOrg.filter((d) => {
          return (
            d.StorageID == 1 &&
            (d.ProductName.toLowerCase().indexOf(this.SearchKeyword.toLowerCase()) != -1 || d.Barcode.indexOf(this.SearchKeyword) != -1)
          );
        });
      } else {
        return this.tableDataOrg.filter((d)=>{
          return d.StorageID == 1 
        });
      }

    },
    StorageDst : function (){
      return this.Storage.filter((d)=>{
        return d.ID != 1
      });
    },
    tableColumns: function () {
      return [
        {
          prop: "ProductName",
          label: this.$t("wms.product"),
          minWidth: 90,
          sortable: true,
        },
        {
          prop: "Balance",
          label: this.$t("wms.balance"),
          minWidth: 120,
          sortable: true,
        },
      ];
    },
  },
  data() {
    return {
		isLoading : false,
      StorageID: 0,
      propsToSearch: ["Number", "Email"],
      selectedRows: [],
      showAddModal: false,
      showInOutModal: false,
      SearchKeyword: "",
      md: {
        InventoryID: 0,
        ProductID: "-",
        StorageID: "-",
        Note: "",
        Quantity: "0",
        Cost: 0,
      },
      inOut: {
        InventoryID: 0,
        ProductID: 0,
        StorageID: 0,
        Note: "",
        Quantity: 0,
        Cost: 0,
        Action: "",
        BillFile: null,
        BillCode: "",
      },
      rowEdit: {
        ID: 0,
        Number: "",
      },
      ProductSelect: [],
    };
  },
  mounted() {
    this.listData();
    this.listProduct();
    this.listStorage();
    this.pagination.perPage = 10;
    this.StorageID = this.StorageDst[0].ID;
  },
  methods: {
    ...mapActions({
      InventoryIn: "WmsInventory/InventoryIn",
      InventoryOut: "WmsInventory/InventoryOut",
      InventoryTransfer: "WmsInventory/InventoryTransfer",
      listData: "WmsInventory/listData",
      listProduct: "WmsProduct/listData",
      listStorage: "WmsStorage/listData",
    }),
    handleUpdateSelect() {
      this.showInOutModal = false;

      let amount = parseInt(this.inOut.Quantity);
      if (isNaN(amount)) {
        return;
      }

      let f = this.ProductSelect.filter(
        (d) => d.InventoryID === this.inOut.InventoryID
      );
      if (f.length != 0) {
        let index = this.ProductSelect.indexOf(f[0]);
        this.ProductSelect[index].Quantity += amount;
      } else {
        this.ProductSelect.push({
          Name: this.inOut.ProductName,
          InventoryID: parseInt(this.inOut.InventoryID),
          ProductID: parseInt(this.inOut.ProductID),
          StorageID: 0,
          Quantity: amount,
        });
      }
    },
    handleInventory() {
		this.$router.push({name : "WmsInventory"});
      // this.showAddModal = true;
    },
    handleOut(index, row) {
      this.showInOutModal = true;
      this.inOut.InventoryID = parseInt(row.ID);
      this.inOut.ProductID = parseInt(row.ProductID);
      this.inOut.StorageID = 0;
      this.inOut.ProductName = row.ProductName;
    },
    handlInventoryTransfer() {
      this.showInOutModal = false;
	  this.isLoading = true;

      let Detail = this.ProductSelect.map((d)=>{
          return {
            InventoryMainID : d.InventoryID,
            StorageID : this.StorageID,
            ProductID : d.ProductID,
            Quantity : parseInt(d.Quantity),
          }
        })

      let formData = new FormData();
        formData.append('PartnerID', 1);
        formData.append('Note', this.inOut.Note);
        formData.append('Detail', JSON.stringify(Detail));
        formData.append('BillCode', this.inOut.BillCode);
        formData.append('BillFile', this.inOut.BillFile);



      this.InventoryTransfer(formData)
        .then((resp) => {
          this.listData();
          swal.fire({
            title: this.$t("edit_success"),
            text: ``,
            icon: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          }).then(()=>{
			this.$router.push({name : "WmsInventory"});
            });
        })
        .catch((err) => {
	  		this.isLoading = false;
          swal.fire({
            title: this.$t(err.response.data.Msg),
            text: err.response.data.Cause,
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false,
          });
        });
    },
    handleDelete(index, row) {
      swal
        .fire({
          title: this.$t("delete_confirm"),
          text: this.$t("delete_confirm_question") + row.Name,
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          buttonsStyling: false,
        })
        .then((result) => {
          //  let index = this.ProductSelect.indexOf(row)
          this.ProductSelect.splice(index, 1);
        });
    },

    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
     filesChange(files) {
      console.log(files[0])
        this.inOut.BillFile = files[0]
    }
  },
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
